import { selectLanguage } from 'containers/Login/loginSlice'
import useLanguage from 'hooks/useLanguage'
import { useReduxSelector } from 'store'
import React, { useState } from 'react'
import PlFlag from 'assets/pol.png'
import EnFlag from 'assets/en.png'

type Flags = 'pl' | 'en'
const flags = {
  pl: <img src={PlFlag} alt='language flag' />,
  en: <img src={EnFlag} alt='language flag' />
}

const LanguageSelect: React.FC = () => {
  const language: Flags = useReduxSelector(selectLanguage)
  const [isExpanded, setExpanded] = useState(false)
  const updateLanguage = useLanguage()

  const secondLanguage = language === 'pl' ? 'en' : 'pl'

  return (
    <div
      className='languageSelect'
      onClick={() => {
        setExpanded(!isExpanded)
      }}>
      <div className='languageSelect__btn'>
        {flags[language]}
        <i className='icon icon--arrow-drop-down' />
      </div>
      {isExpanded && <div
        className='languageSelect__dropdown'
        onClick={() => {
          updateLanguage(secondLanguage)
        }}>
        {flags[secondLanguage]}
      </div>}
    </div>
  )
}

export default LanguageSelect